import { DestroyRef, inject } from '@angular/core';
import {
  InactivityBeforeLogoutHandler,
  InactivityLogoutService,
} from './inactivity-logout.service';

export interface BindInactivityBeforeLogoutOptions {
  /** Stable key for the active screen; replaces any prior handler for that key. */
  key?: string;
  /** Unregisters when the host is destroyed; defaults to injected `DestroyRef`. */
  destroyRef?: DestroyRef;
}

/**
 * Registers a before-logout handler and unregisters it when the host is destroyed.
 */
export function bindInactivityBeforeLogout(
  handler: InactivityBeforeLogoutHandler,
  options?: BindInactivityBeforeLogoutOptions,
): void {
  const service = inject(InactivityLogoutService);
  const destroyRef = options?.destroyRef ?? inject(DestroyRef);
  const unregister = options?.key
    ? service.registerBeforeLogout(options.key, handler)
    : service.registerBeforeLogout(handler);
  destroyRef.onDestroy(unregister);
}
